import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';

class FavoriteChart extends Component {

  render() {

    let {
      new_favorites,
      dates
    }
      = this.props;


    let sum_new_favorites = new_favorites.reduce((t, i) => t += i, 0);
    let count_new_favorites = new_favorites.size;

    let ary_new_favorites = new_favorites.toArray();
    let ary_dates = dates.toArray();

    return (
      <Bar
        // height={200}
        data={{
          datasets: [
            {
              label: 'likes',
              data: ary_new_favorites,
              backgroundColor: 'black',
              hoverBackgroundColor: 'deepskyblue'
            }
          ],
          labels: ary_dates
        }}
        options={{
          animation:{
            duration: 0
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            display: true,
            fontColor: 'deepskyblue',
            fontSize: 16,
            text: `${sum_new_favorites.toLocaleString()} likes ` +
            `/ ${count_new_favorites} hours`
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItem, data) => {
                return tooltipItem.yLabel.toLocaleString();
              })
            }
          },
          scales: {
            xAxes: {
              0: {
                maxBarThickness: 20,
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  autoSkip: true,
                  display: false,
                  fontSize: 11,
                  fontColor: 'blueviolet',
                  callback: ((value, index, values) => {
                    if ((index === 0) || (index === (count_new_favorites - 1))) {
                      return value;
                    }
                  })
                }
              }
            },

            yAxes: {
              0: {
                display: false,
              }
            }
          }
        }}
      />
    );
  }
}


export default FavoriteChart;


// WEBPACK FOOTER //
// ./src/containers/engage/charts/FavoriteChart.js